import { FormContext, FormControlError, FormGroup, FormLabel, Typeahead } from '@hai/ui-react';
import { ITypeaheadListItemsProps } from '@hai/ui-react/dist/types';
import React, { SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { generateDataAuto } from 'src/js/util/automation';
import { FormChangeHandler } from 'src/js/util/global-type';

interface Props {
  alwaysOpenWhenClicked?: boolean;
  className?: string;
  disabled?: boolean;
  hideSearchIcon?: boolean;
  listItems: ITypeaheadListItemsProps[];
  name?: string;
  placeholder?: string;
  selectedValue: string;
  showAllItems?: boolean;
  title?: string;
  onBlur?: (e: SyntheticEvent) => void;
  onChange?: FormChangeHandler;
  onEnterKey?: (e: SyntheticEvent) => void;
  onSelect?: (lang: string | undefined) => void;
}

export const FormTypeahead: React.FunctionComponent<Props> = ({
  alwaysOpenWhenClicked,
  className,
  hideSearchIcon,
  listItems,
  name,
  placeholder,
  selectedValue,
  showAllItems,
  title,
  onBlur,
  onChange,
  onEnterKey,
  onSelect,
}) => {
  const { t } = useTranslation();

  return (
    <FormContext.Consumer>
      {(formContext: any) => {
        const meta = formContext?.getFieldMeta(name);
        const hasErrors = meta.error && meta.touched;

        return (
          <FormGroup className={className} data-auto={generateDataAuto('form_group', name)}>
            <FormLabel>{title}</FormLabel>
            <Typeahead
              name={name}
              noMatches={t('general.noMatches')}
              initialValue={selectedValue} // workaround for HAIUI-2038, remove after upgrading haiui
              selectedValue={selectedValue}
              listItems={listItems}
              invalid={hasErrors}
              placeholder={placeholder}
              alwaysOpenWhenClicked={alwaysOpenWhenClicked}
              hideSearchIcon={hideSearchIcon}
              showAllItems={showAllItems}
              showAllOnExpand={true}
              onBlur={onBlur}
              onChange={onChange}
              onEnterKey={onEnterKey}
              onSelect={onSelect}
            />
            <FormControlError show={hasErrors} mssg={meta.error} />
          </FormGroup>
        );
      }}
    </FormContext.Consumer>
  );
};
